import http from "./http";

export const sendOwnerOtp = (phone) => {
  return http.post("/auth/send-owner-otp/", {
    phone_number: phone,
  });
};

export const verifyOwnerOtp = (phone, code) => {
  return http.post("/auth/verify-owner-otp/", {
    phone_number: phone,
    code: code,
  });
};
